@if (this.getVisible()) {
  <aside class='sidebarContainer' [class.sidebarContainerFull]='isFullMenu'>
    <div class='sidebarBrand'>
      <img src='/assets/{{ this.getLogo() }}' class='logo' alt='logo'/>
    </div>
    <button type='button' class='collapseToggle' (click)='this.isFullMenu = !this.isFullMenu'>
      <i class="fas {{ this.isFullMenu ? 'fa-angle-double-left' : 'fa-angle-double-right' }} fa-fw"></i>
      @if (isFullMenu) {
        <span>Collapse</span>
      }
    </button>
    <ul class='menuItems'>
      @for (item of this.menuItems; track item) {
        @if (item.subscribed) {
          <li>
            @if (item.subItems.length === 0) {
              <a
                [class.active]='isActive(item.isActive)'
                placement="right"
                tooltip="{{item.title}}"
                data-container='body'
                routerLink='{{item.link}}'
                (click)='goToLink(item.link)'
                >
                <span class='{{item.icon}} fa-fw'></span>
                @if (isFullMenu) {
                  <span class='itemLabel'>{{ item.title }}</span>
                }
              </a>
            }
            @if (item.subItems.length > 0 && this.isItemShown(item.subItems)) {
              <a
                [class.active]='isActive(item.isActive)'
                placement="right"
                tooltip="{{item.title}}"
                routerLink='{{item.link}}'
                (click)='item.display = !item.display'
                >
                @if (item.display) {
                  <span class='fas fa-caret-square-left fa-fw'></span>
                }
                @if (!item.display) {
                  <span class='{{item.icon}} fa-fw'></span>
                }
                @if (isFullMenu) {
                  <span class='itemLabel'>{{ item.title }}</span>
                }
              </a>
            }
            @if (item.display) {
              <ul class='subMenu'>
                @for (subItem of item.subItems; track subItem) {
                  @if (subItem.subscribed) {
                    <li>
                      <a class='subItemLink'
                        [class.active]='isActive(subItem.isActive)'
                        placement="right"
                        data-container='body'
                        tooltip="{{subItem.title}}"
                        routerLink='{{subItem.link}}'
                        (click)='goToLink(subItem.link)'
                        ><i class="{{subItem.icon}} fa-fw"></i>
                        @if (isFullMenu) {
                          <span class='itemLabel'>{{ subItem.title }}</span>
                        }
                      </a>
                    </li>
                  }
                }
              </ul>
            }
          </li>
        }
      }
    </ul>
  </aside>
}
